import { render, staticRenderFns } from "./PreviewSideBar.vue?vue&type=template&id=9c645e38&"
import script from "./PreviewSideBar.vue?vue&type=script&lang=js&"
export * from "./PreviewSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports